import { ConfigurationDataProps, Endpoint, Provider, ProviderConfigurationService } from '@philips-emr/hpms-provider-commons';
import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { ThemeColor, ThemeTonalRange } from '@philips-emr/tws-constants';
import { ConfigurationService, HttpService, LanguageService, LocaleService, MessageService, ThemeService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationContext, Information } from '@philips-emr/tws-foundation/lib/context';

import { BaseEndpoint } from '../endpoint';
import { BaseRoute, FOUNDATION_ROUTES } from '../route';

import { registriesModules } from './modules';

interface Theme {
  dsColorRange: ThemeColor;
  dsAccentColor: ThemeColor;
  dsNavTonalRange: ThemeTonalRange;
  dsLoginTonalRange: ThemeTonalRange;
}

interface InternalInformation extends Information {
  providers: Provider[],
}

function map(obj: object): InternalInformation {
  const response = obj as any;
  const information = response.body as InternalInformation;
  providerContext.init(information.providers);

  return information;
}

export function bootstrap(): Promise<void> {
  const conf = HttpService.get(Endpoint.GET.SSO_ENABLED).then((resp) => {
    if (resp.body) {
      ConfigurationService.setAuthenticationConfiguration({
        clientId: 'providerHpms',
        endpointMappers: {
          // @ts-ignore
          information: map,
        },
        endpoints: {
          information: {
            url: BaseEndpoint.INFORMATION,
            method: HttpMethod.GET,
          },
          refresh: {
            url: BaseEndpoint.REFRESH,
            method: HttpMethod.POST,
          },
          revoke: {
            url: BaseEndpoint.REVOKE,
            method: HttpMethod.POST,
          },
        },
        inactivity: {
          time: 15 * 60 * 1000,
        },
        openIDConnect: {
          callbackRoute: FOUNDATION_ROUTES.OPENID_CONNECT_CALLBACK,
          externalLoginURL: '/provider-service/resources/sso',
          errorRoute: FOUNDATION_ROUTES.SSO_ERROR_ROUTE,
        },
        routes: {
          custom: [
            FOUNDATION_ROUTES.NEW_PW,
            FOUNDATION_ROUTES.CONFIRM_USER,
            FOUNDATION_ROUTES.CONFIRM_USER_FAIL,
            FOUNDATION_ROUTES.CONFIRM_USER_NEW_PW,
            FOUNDATION_ROUTES.RENEW_PW,
            FOUNDATION_ROUTES.SSO_CALLBACK,
            FOUNDATION_ROUTES.SSO_ERROR_ROUTE,
          ],
          forgotPassword: FOUNDATION_ROUTES.FORGOT_PW,
          home: FOUNDATION_ROUTES.HOME,
          inactivity: BaseRoute.INACTIVITY,
          login: FOUNDATION_ROUTES.LOGIN,
        },
      });
    } else {
      ConfigurationService.setAuthenticationConfiguration({
        clientId: 'providerHpms',
        endpointMappers: {
          // @ts-ignore
          information: map,
        },
        endpoints: {
          information: {
            url: BaseEndpoint.INFORMATION,
            method: HttpMethod.GET,
          },
          refresh: {
            url: BaseEndpoint.REFRESH,
            method: HttpMethod.POST,
          },
          revoke: {
            url: BaseEndpoint.REVOKE,
            method: HttpMethod.POST,
          },
        },
        inactivity: {
          time: 15 * 60 * 1000,
        },
        routes: {
          custom: [
            FOUNDATION_ROUTES.NEW_PW,
            FOUNDATION_ROUTES.CONFIRM_USER,
            FOUNDATION_ROUTES.CONFIRM_USER_FAIL,
            FOUNDATION_ROUTES.CONFIRM_USER_NEW_PW,
            FOUNDATION_ROUTES.RENEW_PW,
            FOUNDATION_ROUTES.SSO_CALLBACK,
            FOUNDATION_ROUTES.SSO_ERROR_ROUTE,
          ],
          forgotPassword: FOUNDATION_ROUTES.FORGOT_PW,
          home: FOUNDATION_ROUTES.HOME,
          inactivity: BaseRoute.INACTIVITY,
          login: FOUNDATION_ROUTES.LOGIN,
        },
      });

    }

    applicationContext.setTitle(MessageService.translate('provider.application-name'));

    registriesModules();

    const themePromise = HttpService.get(BaseEndpoint.THEME)
      //@ts-ignore
      .then(response => {
        let { dsColorRange, dsAccentColor, dsNavTonalRange, dsLoginTonalRange } = response.body as Theme;

        dsColorRange = dsColorRange || ThemeColor.GREEN;
        dsAccentColor = dsAccentColor || ThemeColor.AQUA;
        dsLoginTonalRange = dsLoginTonalRange || ThemeTonalRange.ULTRA_LIGHT;
        dsNavTonalRange = dsNavTonalRange || ThemeTonalRange.BRIGHT;

        ThemeService.setColors(dsColorRange, dsAccentColor as any);
        ThemeService.setContentTonalRange(dsLoginTonalRange);
        ThemeService.setNavigationTonalRange(dsNavTonalRange);
        ProviderConfigurationService.setLoginTonalRange(dsLoginTonalRange);
        return response.body as ConfigurationDataProps;
      });

    ProviderConfigurationService.setFileuploaderConfig();
    ProviderConfigurationService.setConfigurationData(themePromise);

    LanguageService.setCurrentLanguage('pt-BR');
    LocaleService.init({ defaultLocale: 'pt-BR', supportedLocales: ['pt-BR'] });
  });
  return Promise.all([conf]).then(() => Promise.resolve());
}
